export default __webpack_public_path__ + "static/media/logo.75ec7495.jpg";